'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes", "sx"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ConversationHeaderActions } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { useChatConversationUtilityClasses } from "./chatConversationClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatConversationHeaderActions');
const ChatConversationHeaderActionsStyled = styled('div', {
  name: 'MuiChatConversation',
  slot: 'HeaderActions',
  overridesResolver: (_, styles) => styles.headerActions
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  marginInlineStart: 'auto'
}));
const ChatConversationHeaderActions = /*#__PURE__*/React.forwardRef(function ChatConversationHeaderActions(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatConversationHeaderActions'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp,
      sx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatConversationUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(ConversationHeaderActions, _extends({
    ref: ref
  }, other, {
    slots: _extends({
      actions: slots?.actions ?? ChatConversationHeaderActionsStyled
    }, slots),
    slotProps: _extends({}, slotProps, {
      actions: _extends({
        className: clsx(classes.headerActions, className),
        sx
      }, slotProps?.actions)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatConversationHeaderActions.displayName = "ChatConversationHeaderActions";
process.env.NODE_ENV !== "production" ? ChatConversationHeaderActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  slotProps: PropTypes.object,
  slots: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export { ChatConversationHeaderActions };